// PartCPage7.jsx - Part C Page 7 for HPC Report (Pixel-perfect redesign - Stage 3 Peer Feedback with yellow theme and stick figure)
import React from 'react';

const PartCPage7 = ({ data }) => {
  const studentFields = data || {};

  const calculateTotal = (category) => {
    if (!category) return 0;
    let total = 0;
    if (category.item_1) total++;
    if (category.item_2) total++;
    if (category.item_3) total++;
    return total;
  };

  const renderCategory = (categoryName, title, items) => {
    const category = studentFields[categoryName] || {};

    return (
      <div style={{ marginBottom: '12px' }}>
        <div style={{
          backgroundColor: '#D4AF37',
          color: 'black',
          padding: '6px 12px',
          fontWeight: 'bold',
          fontSize: '11px',
          marginBottom: '0'
        }}>
          {title}
        </div>
        <div style={{
          fontSize: '10px',
          padding: '10px 12px',
          backgroundColor: '#FFF9E6',
          minHeight: '80px'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #333',
                marginRight: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '1px',
                backgroundColor: 'white'
              }}>
                {category[`item_${index + 1}`] && '✓'}
              </div>
              <span style={{ lineHeight: '1.4' }}>{item}</span>
            </div>
          ))}

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginTop: '12px',
            paddingTop: '8px'
          }}>
            <span style={{ marginRight: '10px', fontWeight: 'bold', fontSize: '10px' }}>Total number of (✓):</span>
            <div style={{
              width: '35px',
              height: '35px',
              border: '3px solid #D4AF37',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
              backgroundColor: 'white'
            }}>
              {calculateTotal(category)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Decorative top-right corner */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Stage 3 Header - Orange */}
      <div style={{
        fontSize: '14px',
        fontWeight: 'bold',
        marginBottom: '10px',
        textAlign: 'center',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '8px'
      }}>
        Stage 3
      </div>

      {/* Peer Feedback Label - Yellow/Gold */}
      <div style={{
        fontSize: '12px',
        fontWeight: 'bold',
        marginBottom: '12px',
        backgroundColor: '#D4AF37',
        color: 'black',
        padding: '6px 12px',
        display: 'inline-block'
      }}>
        Peer Feedback
      </div>

      {/* Instructions */}
      <div style={{
        fontSize: '10px',
        marginBottom: '15px',
        padding: '0',
        fontWeight: 'bold',
        lineHeight: '1.5'
      }}>
        Tick (✓) all statements that apply.
      </div>

      {/* Awareness Category */}
      {renderCategory('awareness', 'Awareness', [
        'My peer presented a revised draft that was clear enough to review.',
        'There was a good fit between the research problem and the approach to data collection.',
        'The revised draft of the interview was appropriate and easy to understand.'
      ])}

      {/* Sensitivity Category */}
      {renderCategory('sensitivity', 'Sensitivity', [
        'My peer was able to receive my feedback in an open and respectful manner.',
        'My peer was willing to modify the revised draft based on my suggestions.',
        'The wording of the interview was respectful of the respondents\' emotions and concerns.'
      ])}

      {/* Creativity Category */}
      {renderCategory('creativity', 'Creativity', [
        'My peer was willing to consider alternate methods of data collection.',
        'My peer was willing to consider alternate groups of respondents as a source of data.',
        'My peer was able to think different ways of motivating the respondents to answers.'
      ])}

      {/* Stick figure with speech bubble and text area */}
      <div style={{ display: 'flex', gap: '15px', alignItems: 'center', marginBottom: '15px' }}>
        {/* Stick figure with speech bubble */}
        <div style={{ flexShrink: 0, textAlign: 'center' }}>
          {/* Speech bubble */}
          <div style={{
            backgroundColor: 'white',
            border: '2px solid black',
            borderRadius: '15px',
            padding: '10px 15px',
            fontSize: '9px',
            lineHeight: '1.3',
            maxWidth: '140px',
            marginBottom: '8px',
            textAlign: 'center',
            position: 'relative'
          }}>
            Leave some words of appreciation/ encouragement for your peer.
            {/* Speech bubble pointer */}
            <div style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderTop: '10px solid black'
            }} />
            <div style={{
              position: 'absolute',
              bottom: '-6px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '6px solid transparent',
              borderRight: '6px solid transparent',
              borderTop: '8px solid white'
            }} />
          </div>
          {/* Stick figure */}
          <svg width="60" height="80" viewBox="0 0 60 80" style={{ display: 'block', margin: '0 auto' }}>
            {/* Head */}
            <circle cx="30" cy="15" r="12" stroke="black" strokeWidth="2" fill="white" />
            {/* Body */}
            <line x1="30" y1="27" x2="30" y2="50" stroke="black" strokeWidth="2" />
            {/* Arms */}
            <line x1="30" y1="35" x2="15" y2="45" stroke="black" strokeWidth="2" />
            <line x1="30" y1="35" x2="45" y2="45" stroke="black" strokeWidth="2" />
            {/* Legs */}
            <line x1="30" y1="50" x2="20" y2="70" stroke="black" strokeWidth="2" />
            <line x1="30" y1="50" x2="40" y2="70" stroke="black" strokeWidth="2" />
          </svg>
        </div>

        {/* Text area */}
        <div style={{ flex: 1 }}>
          <div style={{
            padding: '12px 15px',
            fontSize: '10px',
            minHeight: '140px',
            backgroundColor: '#FFF9E6',
            borderRadius: '15px',
            lineHeight: '1.4'
          }}>
            {studentFields.peer_appreciation || ''}
          </div>
        </div>
      </div>

      {/* Arrow pointing from speech bubble to text box */}
      <div style={{
        position: 'absolute',
        left: '230px',
        top: '730px',
        fontSize: '24px',
        color: '#D4AF37',
        fontWeight: 'bold'
      }}>
        ➜
      </div>

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '11px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        26
      </div>

      {/* Bottom corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartCPage7;
